import {FormControl, FormField} from 'platform/components';

import {UseFormReturn, useWatch} from 'react-hook-form';

import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {openPredefinedNotesDropdown} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {RentalOrderNodeContext} from '../../../../../constants/RentalOrderNodeContext';
import {ReturnVehicleFormValues} from '../types/ReturnVehicleFormValues';

interface RentalNoteProps extends RequiredTestIdProps {
  control: FormControl<ReturnVehicleFormValues>;
  formApi: UseFormReturn<ReturnVehicleFormValues>;
}

export function RentalNote(props: RentalNoteProps) {
  const rentalOrderNote = useWatch({control: props.control, name: 'rentalOrderNote'});

  return (
    <FormField
      control={props.control}
      type="textarea"
      name="rentalOrderNote"
      label={i18n.t('page.rentalOrder.labels.rentalOrderNote')}
      data-testid={suffixTestId('rentalOrderNote', props)}
      labelActions={[
        {
          title: i18n.t('general.labels.templates'),
          leftIcon: 'content/add_circle',
          onClick: (event) => {
            openPredefinedNotesDropdown(event, {
              note: rentalOrderNote ?? null,
              resource: EntityResourceIds.rentalOrder,
              context: RentalOrderNodeContext.returnVehicleNote,
              onPrefill: (text) => {
                props.formApi.setValue('rentalOrderNote', text);
              },
              'data-testid': suffixTestId('rentalOrderNoteTemplates', props),
            });
          },
        },
      ]}
    />
  );
}
